import Dialog from "../dialogs/Dialog";
import React, {useContext, useState} from "react";
import {PathwayUser, Roles, Projects} from "../../redux/types/firebase";
import { Card, CardContent, CardHeader, TextField } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import {connect} from "react-redux";
import {UserRoles} from "./UserRoles";
import {FirebaseContext} from "../firebase/FirebaseProvider";

const useStyles = makeStyles(theme => ({
    card: {
        display: 'flex',
        flexGrow: 1,
        flexDirection: 'column',
        minWidth: 500,
        minHeight: 200
    },
}));

interface Props {
    user: PathwayUser
    userKey: string
    onClose: () => void
    projects: Projects
}
function UserDetails({onClose, projects, user, userKey}: Props) {
    const [name, setName] = useState(user.name || userKey);
    const classes = useStyles();
    const {setUserMember} = useContext(FirebaseContext);
    const handleRolesChange = (roles: Roles) => {
        setUserMember(userKey, "roles", roles);
    };
    const handleUserNameChange = ({currentTarget}: React.ChangeEvent<HTMLInputElement>) => {
        setName(currentTarget.value);
    }
    const handleUserNameBlur = ({currentTarget}: React.FocusEvent<HTMLInputElement>) => {
        setUserMember(userKey, "name", name);
    }

    return (
        <Dialog onClose={onClose}>
            <Card className={classes.card}>
                <CardContent>
                    <CardHeader title={name} subheader="Roles"/>
                    <TextField label={"User Name"} value={name} onChange={handleUserNameChange} onBlur={handleUserNameBlur}/>
                    <UserRoles projects={projects} onRolesChange={handleRolesChange} roles={user.roles || {}}/>
                </CardContent>
            </Card>
        </Dialog>
    );
}
const mapStateToProps = (store: never) => ({
});

export default connect(mapStateToProps, {
})(UserDetails);
